import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { getRole } from '@completion/selectors';
import { ProjectAccessRoles } from '@completion/models';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private store: Store,
    private router: Router,
  ) {}

  canActivate(): Observable<boolean> {
    return this.store.select(getRole).pipe(
      map((role) => {
        if (role === ProjectAccessRoles.VENDOR) {
          this.router.navigateByUrl('/vendor');
          return false;
        }
        return true;
      }),
    );
  }
}
